import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
  useNavigate,
  Link,
} from "react-router-dom";
import { Provider, useDispatch, useSelector } from "react-redux";
import { store, RootState, AppDispatch } from "./redux/store";
import "./App.css";
import { Button, ConfigProvider } from "antd";
import { Layout } from "antd";
import { AppRoutes } from "./routes/AppRoutes";
import { AdminSidebar } from "./features/AdminSidebar";
import { logout } from "./redux/slices/authSlice";

const { Header, Sider, Content } = Layout;

function AppContent() {
  const location = useLocation();
  const token = localStorage.getItem("token");
  const isAuthenticated = !!token;
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const isLoginPage = location.pathname === "/login";
  const { user } = useSelector((state: RootState) => state.auth);
  const handleLogout = () => {
    dispatch(logout());
    navigate("/login");
  };

  if (!isAuthenticated && !isLoginPage) {
    window.location.href = "/login";
    return null;
  }

  if (isLoginPage) {
    return (
      <Layout style={{ minHeight: "100vh" }}>
        <Content>
          <AppRoutes />
        </Content>
      </Layout>
    );
  }

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Header
        style={{
          position: "sticky",
          top: 0,
          zIndex: 1000,
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "0 12px",
          color: "#fff",
          fontWeight: 600,
          fontSize: 18,
          background: "#001529",
          flexWrap: "wrap",
          minHeight: 64,
        }}
      >
        <div style={{ marginRight: 16 }}>
          {user && user.isEsimReseller ? "POS eSIM" : "POS SIM"}
        </div>
        {!user.isAdmin && (
          <div
            style={{
              display: "flex",
              gap: 12,
              flexWrap: "wrap",
              justifyContent: "center",
              margin: "4px 0",
            }}
          >
            {user.isEsimReseller && (
              <>
                <Link to="/" style={{ color: "#fff", padding: "4px 8px" }}>
                  Packages
                </Link>
                <Link
                  to="/topUpEsim"
                  style={{ color: "#fff", padding: "4px 8px" }}
                >
                  Top up
                </Link>
              </>
            )}
            <Link to="/balance" style={{ color: "#fff", padding: "4px 8px" }}>
              Balance
            </Link>
          </div>
        )}
        <Button type="primary" danger size="small" onClick={handleLogout}>
          Logout
        </Button>
      </Header>

      <Layout style={{ minHeight: "calc(100vh - 64px)" }}>
        {user.isAdmin && <AdminSidebar />}
        <Layout style={{ padding: "12px", overflow: "auto" }}>
          <Content style={{ maxWidth: "100%", overflowX: "hidden" }}>
            <AppRoutes />
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
}

export default function App() {
  return (
    <Provider store={store}>
      <ConfigProvider>
        <Router>
          <AppContent />
        </Router>
      </ConfigProvider>
    </Provider>
  );
}
//
